<template>
  <div>
    <MailboxDetailsDialog ref="detailsDialog" />
    <NewMailboxDialog
      ref="newMailboxDialog"
      :client="client"
      @reload="$refs.portlet.reload()"
    />

    <TablePortlet
      ref="portlet"
      code="clientMailboxPortlet"
      :fetcher="fetchData"
      :spec="spec"
      :selected="selectedIds"
      :selectable="true"
      @rowClicked="showRowDetails"
    >
      <v-toolbar-title>Mailbox</v-toolbar-title>

      <v-btn icon small class="ml-2" @click="reload">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>

      <v-spacer />

      <ODialog ref="infosDialog">
        <v-card>
          <v-list class="maxh-4">
            <OListItem
              rightIcon="mdi-chevron-right"
              title="(Todos)"
              @click="select(null)"
            />
            <OListItem
              v-for="info in allInfos"
              :key="info.code"
              rightIcon="mdi-chevron-right"
              :title="info.text"
              @click="select(info)"
            />
          </v-list>
        </v-card>
      </ODialog>
      <v-btn small text @click="$refs.infosDialog.$open()">
        <span v-if="filterInfo == null">Tipo: (todos)</span>
        <span v-else>Tipo: {{ filterInfo }}</span>
      </v-btn>

      <v-spacer />

      <v-btn icon small class="ml-2" @click="newItem">
        <v-icon>add</v-icon>
      </v-btn>

      <v-btn
        icon
        small
        class="ml-2"
        :disabled="selectedIds.length < 1"
        @click="cancelItems"
      >
        <v-icon>mdi-trash-can-outline</v-icon>
      </v-btn>
    </TablePortlet>
  </div>
</template>

<script>
import { MailboxItem } from '@/models'
import TablePortlet from '../../../../components/TablePortlet.vue'
import { portletSpec } from './mailbox-columns'
import MailboxDetailsDialog from './DetailsDialog.vue'
import NewMailboxDialog from './NewMailboxDialog.vue'
import { allInfos } from './Informations.js'
import OListItem from 'oderon-vue/cpts/lists/OListItem.vue'

export default {
  components: {
    TablePortlet,
    MailboxDetailsDialog,
    NewMailboxDialog,
    OListItem
  },
  props: {
    client: { required: true }
  },
  data() {
    return {
      filterInfo: null,
      spec: portletSpec,
      selectedIds: [],
      allInfos
    }
  },
  watch: {
    client() {
      this.$refs.portlet.reloadFromStart()
    },
    filterInfo() {
      this.$refs.portlet.reloadFromStart()
    }
  },
  methods: {
    reload() {
      this.$refs.portlet.reload()
    },
    async fetchData({ limit, offset }) {
      return await MailboxItem.findAll({
        clientIds: this.client.id,
        information: this.filterInfo,
        limit,
        offset
      })
    },

    async showRowDetails({ row }) {
      this.$refs.detailsDialog.open(row.id)
    },

    async select(info) {
      this.filterInfo = info == null ? null : info.code
      this.$refs.infosDialog.$dismiss()
    },

    async newItem() {
      this.$refs.newMailboxDialog.open()
    },

    async cancelItems() {
      let res = await this.$confirm({
        message: 'Deseja realmente cancelar estes itens?',
        okText: 'Sim, cancelar',
        cancelText: 'Não, manter'
      })

      if (res) {
        this.$loading(async () => {
          for (let id of this.selectedIds) {
            await MailboxItem.delete(id)
          }
          this.$snack('Itens cancelados com sucesso')
          this.$emit('reload')
        })
      }
    }
  }
}
</script>

<style></style>
